export default "__VITE_ASSET__67a1b62e__"